var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Glyph",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.324 9.67498C10.2966 9.64757 10.2677 9.62254 10.2376 9.59987C10.9517 8.64932 11.3747 7.46776 11.3747 6.18738C11.3747 3.04633 8.82842 0.5 5.68737 0.5C2.54632 0.5 0 3.04633 0 6.18738C0 9.32844 2.54632 11.8748 5.68737 11.8748C6.96776 11.8748 8.14932 11.4517 9.09988 10.7376C9.12255 10.7677 9.14758 10.7966 9.17498 10.824L11.613 13.262C11.9303 13.5793 12.4447 13.5793 12.762 13.262C13.0793 12.9447 13.0793 12.4303 12.762 12.113L10.324 9.67498ZM9.74978 6.18738C9.74978 8.43099 7.93098 10.2498 5.68737 10.2498C3.44377 10.2498 1.62496 8.43099 1.62496 6.18738C1.62496 3.94377 3.44377 2.12497 5.68737 2.12497C7.93098 2.12497 9.74978 3.94377 9.74978 6.18738Z",
    fill: "#CDCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0833066b497c9c251ca0085ea05e8766.svg";
export { ForwardRef as ReactComponent };